/* Variantvaljarens motor. Lag inline i blocks/on-variant-picker.liquid och
   vagde 62 755 byte i varje sidvisning. Flyttad hit 2026-10-09, och pa nytt
   2026-10-13 fran snabbfixens version vid sammanslagningen med LIVE (punkt 16).

   Den ar ett custom element, sa den startar om av sig sjalv nar Horizon ritar
   om en del av sidan och nar en sektion laddas om i temaredigeraren: nya
   <on-variant-picker> uppgraderas sa fort definitionen finns. Ingen egen
   lyssnare pa shopify:section:load behovs darfor.

   Noll Liquid i filen. Prisformatet las ur ett renderat exempel i markupen,
   aldrig gissat ur shop.money_format. */

/* INP (omgång 52): text skrivs i den befintliga textnoden när elementet bara har en.
   Att byta textContent tar bort och lägger till en nod, och då räknar webbläsaren om stilen
   för hela sidan (temats :has()-regler): ~100 ms per byte på mobil, mätt. Samma text syns. */
var __onTxt = window.__onTxt || (window.__onTxt = function (el, s) {
  if (!el) return;
  s = s == null ? '' : String(s);
  var f = el.firstChild;
  if (s !== '' && f && f.nodeType === 3 && !f.nextSibling) { if (f.nodeValue !== s) f.nodeValue = s; return; }
  el.textContent = s;
});

/* En rad, aldrig avbrutna ord (omgång 56: passformsraden och sparraden). Texterna provas i tur
   och ordning, var och en från elementets egen storlek ner till 12 px (den sista till 11); den första som ryms
   vinner. Elementet har white-space: nowrap och overflow: hidden, så scrollWidth säger om
   texten ryms. Körs efter målningen (INP): rAF + setTimeout, senaste anropet gäller. */
var __onFitLine = window.__onFitLine || (window.__onFitLine = function (el, texts) {
  if (!el) return;
  texts = (texts || []).filter(Boolean);
  if (!texts.length) { el.style.fontSize = ''; __onTxt(el, ''); return; }
  if (el.textContent !== texts[0]) __onTxt(el, texts[0]);
  var tok = (el.__onFitTok = (el.__onFitTok || 0) + 1);
  requestAnimationFrame(function () {
    setTimeout(function () {
      if (tok !== el.__onFitTok || !el.isConnected || !el.clientWidth) return;
      el.style.fontSize = '';
      var base = parseFloat(getComputedStyle(el).fontSize) || 13;
      for (var i = 0; i < texts.length; i++) {
        if (el.textContent !== texts[i]) __onTxt(el, texts[i]);
        /* Kortare form hellre än pytteliten text: bara den sista får ner till 11 px. */
        var min = i < texts.length - 1 ? 12 : 11;
        for (var fs = base; fs >= min; fs -= 0.5) {
          el.style.fontSize = fs === base ? '' : fs + 'px';
          if (el.scrollWidth <= el.clientWidth + 0.5) return;
        }
      }
    }, 0);
  });
});

/* Mudd (benslut med resår) på butikens tolv språk, som optionsvärdet heter i butiken
   (avläst 2026-10-24 ur produktens .js per språk). Delas med on-size-quiz.js. */
var __onCuffRe = window.__onCuffRe || (window.__onCuffRe = /^(mudd|manchet|resori|bündchen|boord|cuffed|cuffs?|bord-côte|polsino|puño|ściągacz|punho)$/i);

/* Quizets svar per produkt (omgång 57), sparade av on-size-quiz.js i localStorage
   "on_sq_fit": { handle: { s: storlek, long, short, cuff, h, ts } }. */
var __onQuizFit = window.__onQuizFit || (window.__onQuizFit = function (handle) {
  try { var all = JSON.parse(localStorage.getItem('on_sq_fit') || '{}'); return all[handle] || null; } catch (e) { return null; }
});

/* Kroppslängd ur storlekstabellen (omgång 56). Tabellens egen kolumn Kroppslängd går först.
   Annars ur innerbenet: mitten = innerben / 0,409, ±3,5 cm. Kvoten är avläst ur dagens
   tabeller och Victors egna uppgifter, inte gissad: WFP M (innerben 69) = 165–172 cm
   (Victors exempel), 175 cm lång bär XL eller 2XL i WFP (71–72), och modellen 165 cm bär
   XL i QuickDry (68). Quizets 0,428 hör till en äldre WFP-tabell (XL 74).
   Svar: [från, till] i cm, eller null. */
var __onFitHeight = window.__onFitHeight || (window.__onFitHeight = function (d, lab) {
  if (!d || !lab) return null;
  var key = String(lab).toUpperCase().replace(/\s+/g, '');
  var pick = function (arr) {
    if (!arr) return null;
    for (var i = 0; i < arr.length; i++) if (String(arr[i][0]).toUpperCase().replace(/\s+/g, '') === key) return arr[i][1];
    return null;
  };
  var num = function (v) {
    var m = String(v || '').replace(/(\d),(\d)/g, '$1.$2').match(/\d+(?:\.\d+)?/g);
    if (!m) return null;
    var a = parseFloat(m[0]), b = m.length > 1 ? parseFloat(m[1]) : a;
    return a <= b ? [a, b] : [b, a];
  };
  var b = num(pick(d.body));
  if (b) return [Math.round(b[0]), Math.round(b[1])];
  var l = num(pick(d.legs));
  if (!l) return null;
  /* Omgång 57 (Victor): längd bara när HELA tabellen ger rimliga intervall, ungefär
     150–190 cm (148–192 accepteras). Annars (QuickDry, Aero, barnbyxor) visar raden måtten
     tills tabellen har en kolumn Kroppslängd. */
  var rng = function (v) { var m = v / 0.409; return [Math.round(m - 3.5), Math.round(m + 3.5)]; };
  if (d._hOk == null) {
    d._hOk = (d.legs || []).every(function (r) { var x = num(r[1]); if (!x) return true; var q = rng((x[0] + x[1]) / 2); return q[0] >= 148 && q[1] <= 192; });
  }
  if (!d._hOk) return null;
  return rng((l[0] + l[1]) / 2);
});
  (function () {
    if (customElements.get('on-variant-picker')) return;

    class OnVariantPicker extends HTMLElement {
      connectedCallback() {
        this.engine = this.querySelector('variant-picker.on-vp-engine');
        this.skin = this.querySelector('.on-vp');
        if (!this.engine || !this.skin) return;

        this.onClick = this.onClick.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onVariantUpdate = this.onVariantUpdate.bind(this);

        this.skin.addEventListener('click', this.onClick);
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('variant:update', this.onVariantUpdate);

        this.initSizeGuideLink();

        /* Quizet kan inte rekommendera nagon storlek pa den har produkten.
           Da ska quizknappen och bannern bort, men storleksguiden stanna
           kvar: utan den star kunden helt utan storlekshjalp. */
        this.onQuizGone = this.onQuizGone.bind(this);
        document.addEventListener('on:size-quiz:unavailable', this.onQuizGone);

        // Variantdata behövs även utan multi-läget (lagernotisen hashar variant-ID som paketet gör)
        try { this.vpVariants = JSON.parse((this.querySelector('[data-vp-variants]') || {}).textContent || '[]'); } catch (e) { this.vpVariants = []; }
        try { this.altVariants = JSON.parse((this.querySelector('[data-vp-variants-alt]') || {}).textContent || '[]'); } catch (e) { this.altVariants = []; }
        try { this.swImgs = JSON.parse((this.querySelector('[data-vp-swimgs]') || {}).textContent || '{}'); } catch (e) { this.swImgs = {}; }
        try { this.optNames = JSON.parse((this.querySelector('[data-vp-optnames]') || {}).textContent || '{}'); } catch (e) { this.optNames = {}; }
        // Lagernotis: inställningar + räknare (visas först efter N klick på varianterna)
        this.stockDot = this.getAttribute('data-stock-dot') || 'pulse';
        this.stockDotColor = this.getAttribute('data-stock-dot-color') || '#f46245';
        this.stockTextColor = this.getAttribute('data-stock-text-color') || '#111111';
        this.stockAfter = parseInt(this.getAttribute('data-stock-after') || '2', 10);
        this.readyTxt = this.getAttribute('data-ready') || '';
        this.readyDotColor = this.getAttribute('data-ready-dot') || '#1E7A3C';
        if (isNaN(this.stockAfter)) this.stockAfter = 2;
        this.optionClicks = 0;

        this.updateUrgency();
        this.fitGenderMain();
        var selfGx = this, tGx;
        window.addEventListener('resize', function () { clearTimeout(tGx); tGx = setTimeout(function () { selfGx.fitGenderMain(); }, 150); });
        this.initMulti();
        this.initAddonBundle();
        this.initSizeDefault();
        /* Passformsraden: vald storlek redan vid laddning (?variant=, förvald storlek). */
        this.updateFitRow();
        this.initStickyPick();
        this.initBogoGate();
      }

      /* ── Förvald storlek ──────────────────────────────────────────────────
         Shopify väljer alltid FÖRSTA tillgängliga varianten, vilket blir XS –
         den minsta storleken i sortimentet. Tre lägen:
           first     = låt native bestämma (som förr)
           preferred = välj en angiven storlek, t.ex. L
           none      = ingen förvald storlek; köpknappen spärras tills kunden valt
         Kommer besökaren in på en direktlänk med ?variant= är valet redan gjort
         och vi rör ingenting. Allt failar öppet: kraschar något går köpet igenom. */
      initSizeDefault() {
        try {
          this.sizeMode = this.getAttribute('data-size-mode') || 'first';
          if (this.sizeMode === 'first') return;
          if (new URLSearchParams(location.search).get('variant')) return;

          this.sizeGroup = this.skin.querySelector('.on-vp__group[data-type="size"]');
          if (!this.sizeGroup) return;
          // Omgång 73: är varje storlek slutsåld finns inget att välja. Då står knappen kvar
          // som Slutsåld i stället för att be kunden välja en storlek som inte går att köpa.
          if (!this.sizeGroup.querySelector('.on-variant-option:not([data-available="false"]):not(.is-unavailable)')) return;

          if (this.sizeMode === 'preferred') {
            var want = (this.getAttribute('data-size-pref') || '').trim();
            if (!want) return;
            var btns = this.sizeGroup.querySelectorAll('.on-variant-option');
            for (var i = 0; i < btns.length; i++) {
              var b = btns[i];
              if (b.getAttribute('data-value') !== want) continue;
              if (b.getAttribute('data-available') === 'false') return; // slut i den storleken → låt native stå
              this.setActive(this.sizeGroup.getAttribute('data-fieldset-index'), want);
              this.selectNative(this.sizeGroup.getAttribute('data-fieldset-index'), want);
              return;
            }
            return;
          }

          // none: ingen förvald storlek + spärrad köpknapp
          this.sizeGate = true;
          this.pickText = this.getAttribute('data-size-pick') || 'Choose a size';
          this.clearSize();
          this._onAtcGate = this.onAtcGate.bind(this);
          document.addEventListener('click', this._onAtcGate, true);
          // Köpknappen i sidan renderas EFTER väljaren, så första försöket hittar bara
          // den fästa baren. Två sena omtag fångar den. setTimeout, inte MutationObserver
          // (observern gav märkbar slowdown i det här temat).
          var self = this;
          setTimeout(function () { if (self.sizeGate) { self.setAtcPrompt(true); self.lockScope(true); } }, 0);
          setTimeout(function () { if (self.sizeGate) { self.setAtcPrompt(true); self.lockScope(true); } }, 600);
        } catch (e) { this.sizeGate = false; }
      }

      /* Uppmaningen står på KÖPKNAPPEN, inte bredvid rubriken: "STORLEK  Välj storlek"
         blev kaka på kaka. Etikettvärdet lämnas tomt tills kunden valt. */
      clearSize() {
        if (!this.sizeGroup) return;
        this.sizeGroup.querySelectorAll('.on-variant-option').forEach(function (b) { b.classList.remove('is-active'); });
        var cur = this.sizeGroup.querySelector('[data-current-text]');
        if (cur) __onTxt(cur, '');
        var dd = this.sizeGroup.querySelector('[data-dd-current-text]');
        if (dd) __onTxt(dd, '');
        this.sizeGroup.setAttribute('data-unchosen', '');
        this.lockScope(true);
        this.setAtcPrompt(true);
      }

      /* Låst köpknapp styrs av en KLASS, inte av :has([data-unchosen]).
         :has() räknas inte alltid om när attributet tas bort djupt i trädet –
         knappen blev kvar i det låsta läget trots att spärren var hävd. */
      lockScope(on) {
        var scope = this.section || this.closest('.shopify-section') || document;
        if (scope.classList) scope.classList.toggle('on-cta-is-locked', !!on);
        // Knappen ska INTE tonas ner medan sparren galler - bara texten byter till
        // "Valj storlek". Vi nollar darfor alltid ev. gammal inline-farg (den satt
        // kvar hos besokare som redan laddat sidan) och satter aldrig nagon ny.
        var btns = scope.querySelectorAll ? scope.querySelectorAll('.add-to-cart-button, button[name="add"]') : [];
        Array.prototype.forEach.call(btns, function (b) {
          b.style.removeProperty('background-color');
          b.style.removeProperty('border-color');
        });
      }

      /* Byter köpknapparnas text till "Välj storlek" medan spärren gäller. Gäller BÅDA
         knapparna (sidans och den fästa baren). Originaltexten sparas på elementet så
         den kan läggas tillbaka exakt – vi gissar aldrig fram den. */
      setAtcPrompt(on) {
        /* Inställningen "Köpknappens text före valen" = fast text: knappen behåller
           sin vanliga text (t.ex. KÖP NU) hela tiden. Spärren gäller ändå. */
        var lage = this.getAttribute('data-atc-text');
        if (on && lage === 'buy') on = false;
        /* "Fästa baren: Välj storlek": baren har alltid uppmaningen, köpknappen aldrig. */
        var baraBaren = lage === 'sticky' && this.stickyPick;
        try {
          var scope = this.section || this.closest('.shopify-section') || document;
          var btns = scope.querySelectorAll('.add-to-cart-button, button[name="add"]');
          var txt = this.pickText;
          var sizePick = this.getAttribute('data-size-pick');
          var egna = [this.pickText, sizePick, this.getAttribute('data-bogo-gate')];
          function prompts(t) {
            t = (t || '').trim();
            if (!t) return false;
            for (var i = 0; i < egna.length; i++) { if (egna[i] && egna[i].trim() === t) return true; }
            return false;
          }
          btns.forEach(function (b) {
            var el = b.querySelector('.add-to-cart-text__content > span:first-child')
                  || b.querySelector('.add-to-cart-text__content');
            if (!el) return;
            var paB = on;
            var txtB = txt;
            var iBaren = !!b.closest('sticky-add-to-cart');
            if (baraBaren) paB = iBaren;
            /* Baren säger alltid "Välj storlek", även på BOGO (Victor, omgång 41). */
            if (iBaren) txtB = sizePick || txt;
            if (paB) {
              /* Spara ALDRIG en uppmaning som "original". Knappen renderas efter
                 valjaren och kan hinna fa en prompttext innan vi ser den forsta
                 gangen; sparades den blev "KOP NU" borta for gott och kunden fick
                 sta kvar med "Valj storlek" aven efter att allt var valt. */
              if (el.getAttribute('data-on-orig') === null && !prompts(el.textContent) && el.textContent.trim()) {
                el.setAttribute('data-on-orig', el.textContent);
              }
              if (el.textContent !== txtB) __onTxt(el, txtB);
            } else {
              var o = el.getAttribute('data-on-orig');
              /* Knappen får aldrig bli tom (omgång 41): saknas originalet, eller är
                 det tomt, tas serverns knapptext (data-on-label). */
              if (o === null || !o.trim()) o = (!el.textContent.trim() || prompts(el.textContent)) ? b.getAttribute('data-on-label') : null;
              if (o) __onTxt(el, o);
              el.removeAttribute('data-on-orig');
            }
          });
        } catch (e) { /* knappen får hellre stå kvar orörd än att något går sönder */ }
        if (window.__onCtaFit) window.__onCtaFit();
      }

      /* Spärren gäller BARA så länge kunden inte valt storlek. */
      onAtcGate(e) {
        if (!this.sizeGate) return;
        var btn = e.target.closest('.add-to-cart-button, button[name="add"]');
        if (!btn) return;
        var scope = this.section || this.closest('.shopify-section') || document;
        if (scope !== document && !scope.contains(btn)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.armPending();
        this.flashSize();
      }

      flashSize() {
        if (!this.sizeGroup) return;
        this.sizeGroup.setAttribute('data-nudge', '');
        var g = this.sizeGroup;
        setTimeout(function () { g.removeAttribute('data-nudge'); }, 900);
        try { g.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { g.scrollIntoView(); }
        /* Kopet stoppades for att ingen storlek ar vald. Det ar knuffens forsta
           anledning - och den starkaste, for har har kunden redan visat att den
           vill kopa. */
        this.maybeNudge();
      }

      /* ── Knuffen "Osäker på storleken?" ──────────────────────────────────
         Rutan ligger fardig i DOM:en med hidden. Skriptet bara visar den, bygger
         aldrig text: all copy ar oversatt pa servern.

         Tva anledningar att visa den, bada ur arbetsordern:
           1. kopet stoppades for att ingen storlek var vald (flashSize ovan)
           2. kunden har bytt storlek tva ganger

         "Byte" raknas som att valja en ANNAN storlek an den forra. Forsta klicket
         ar ett val, inte ett byte, sa det raknas inte. Tva byten = tre klick pa
         olika storlekar.

         Den visas hogst en gang per session (sessionStorage), gar att stanga, och
         aldrig ovanpa valkomstpopupen eller cookie-bannern - tva lager som ber om
         samma uppmarksamhet samtidigt far kunden att stanga bada.

         Allt failar oppet: gar nagot fel visas ingen knuff, och kopet fortsatter. */
      /* Ingen cache. Sektionen renderas om vid variantbyte, och en sparad
         nod pekar da pa ett element som inte langre sitter i sidan: rutan skulle
         avslojas i minnet men aldrig synas. Samma falla som fri frakt-baren gick
         i. En querySelector per knuff kostar ingenting. */
      nudgeBox() {
        return this.querySelector('[data-on-szn]');
      }

      nudgeSeen(set) {
        try {
          if (set) { sessionStorage.setItem('on-szn-seen', '1'); return true; }
          return sessionStorage.getItem('on-szn-seen') === '1';
        } catch (e) {
          /* Privat lage eller blockerad lagring: behandla den som sedd, sa den
             inte kan aterkomma gang pa gang under samma besok. */
          return true;
        }
      }

      nudgeBlocked() {
        try {
          if (document.querySelector('.owp.is-open')) return true;
          if (document.querySelector('.on-ck:not([hidden])')) return true;
        } catch (e) { return true; }
        return false;
      }

      countSizePick(val) {
        if (!val) return;
        if (this.lastSize && this.lastSize !== val) {
          this.sizeSwaps = (this.sizeSwaps || 0) + 1;
          if (this.sizeSwaps >= 2) this.maybeNudge();
        }
        this.lastSize = val;
      }

      maybeNudge() {
        /* Ingen ruta i DOM:en = installningen ar av. Da ska inget raknas
           eller markeras heller. */
        if (!this.nudgeBox()) return;
        try {
          var box = this.nudgeBox();
          if (!box || !box.hasAttribute('hidden')) return;
          if (this.nudgeSeen()) return;
          if (this.nudgeBlocked()) return;
          this.nudgeSeen(true);
          box.removeAttribute('hidden');
        } catch (e) { /* tyst: en knuff ar aldrig viktigare an kopet */ }
      }

      onNudgeClick(e) {
        var box = this.nudgeBox();
        if (!box) return;
        if (e.target.closest('[data-on-szn-close]')) { box.setAttribute('hidden', ''); return; }
        if (!e.target.closest('[data-on-szn-go]')) return;
        box.setAttribute('hidden', '');
        /* Quizet forst. Har det inte laddats oppnas storleksguiden i stallet, och
           finns ingen av dem hander ingenting - rutan ar da redan stangd. */
        var quiz = this.querySelector('[data-on-sq-trigger]');
        if (quiz && window.OnSizeQuiz) { quiz.click(); return; }
        var guide = this.querySelector('[data-vp-sizeguide]:not([hidden])');
        if (guide) guide.click();
      }

      resolveSizeGate() {
        if (!this.sizeGate) return;
        this.sizeGate = false;
        if (this.sizeGroup) this.sizeGroup.removeAttribute('data-unchosen');
        this.lockScope(false);
        this.setAtcPrompt(false);
        if (this._onAtcGate) { document.removeEventListener('click', this._onAtcGate, true); this._onAtcGate = null; }
      }

      /* Storleksguide-lanken pa storleksraden. Guideblocket ligger langre ned i
         hogerkolumnen och renderas efter oss, darav de sena passen. Finns ingen guide
         pa sidan (skor utan tabell, guideblocket avstangt) stannar lanken dold - vi
         visar aldrig en genvag som inte leder nagonstans. */
      onQuizGone() {
        var dolj = ['.on-vp__sh-pill', '.on-sqbn', '.on-sqline'];
        /* Lanken ar storleksguiden. Den doljs bara om guiden OCKSA saknas -
           annars tog vi bort den enda hjalp som fortfarande fungerar. */
        var lnk = this.querySelector('.on-vp__sh-link');
        if (lnk && !(lnk.hasAttribute('data-sg-or-quiz') && document.querySelector('[data-sg-open]'))) {
          lnk.setAttribute('hidden', '');
        }
        for (var i = 0; i < dolj.length; i++) {
          var n = this.querySelector(dolj[i]);
          if (n) n.setAttribute('hidden', '');
        }
        /* Guiden ar reserven. I laget "Bara lank" renderas den dold och rors
           inte av initSizeGuideLink - den tands forst har, och bara om det
           finns en guide att oppna. */
        var guide = this.querySelector('[data-vp-sizeguide]');
        if (guide && document.querySelector('[data-sg-open]')) {
          guide.removeAttribute('data-sg-fallback');
          guide.hidden = false;
        }
      }

      initSizeGuideLink() {
        var btn = this.querySelector('[data-vp-sizeguide]');
        if (!btn) return;
        /* Lanken i laget "Bara lank": guiden om den finns, annars quizet.
           Guideblocket renderas efter oss i hogerkolumnen, darav de sena
           passen - samma monster som show() nedan. */
        if (btn.hasAttribute('data-sg-or-quiz')) {
          var sync = function () {
            /* Guiden finns: lanken star kvar och heter Storleksguide. */
            if (document.querySelector('[data-sg-open]')) { btn.hidden = false; return; }
            /* Ingen guide, men ett quiz: lanken byter bade text och mal. */
            if (window.OnSizeQuiz && OnSizeQuiz.instance) {
              btn.hidden = false;
              var alt = btn.getAttribute('data-alt-label');
              var lbl = btn.querySelector('[data-sg-label]');
              if (alt && lbl && lbl.textContent !== alt) __onTxt(lbl, alt);
              return;
            }
            /* Varken eller - da ska den inte synas. En lank som inte leder
               nagonstans ar varre an ingen lank. */
            btn.hidden = true;
          };
          sync();
          setTimeout(sync, 400);
          setTimeout(sync, 1500);
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var t = document.querySelector('[data-sg-open]');
            if (t) { t.click(); return; }
            if (window.OnSizeQuiz && OnSizeQuiz.instance) OnSizeQuiz.instance.open();
          });
          return;
        }
        /* En reserv ska synas forst nar quizet fallit bort, inte direkt.
           Klicket kopplas anda, sa knappen fungerar i samma ogonblick som
           den tands. */
        if (btn.hasAttribute('data-sg-fallback')) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var t = document.querySelector('[data-sg-open]');
            if (t) t.click();
          });
          return;
        }
        function target() { return document.querySelector('[data-sg-open]'); }
        var show = function () { if (target()) btn.hidden = false; };
        show();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show);
        setTimeout(show, 400);
        setTimeout(show, 1500);
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var t = target();
          if (t) t.click();
        });
      }

      disconnectedCallback() {
        if (this.onQuizGone) document.removeEventListener('on:size-quiz:unavailable', this.onQuizGone);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('variant:update', this.onVariantUpdate);
        if (this._onAtc) document.removeEventListener('click', this._onAtc, true);
        if (this._onAddon) document.removeEventListener('on-vp:addon', this._onAddon);
        if (this._onAtcGate) document.removeEventListener('click', this._onAtcGate, true);
      }

      /* Läget "Fästa baren: Välj storlek" (Victor, omgång 36): den fästa baren visar
         alltid uppmaningen och tar kunden till variantväljaren, köpknappen i sidan
         behåller sin vanliga text (KÖP NU, LÄGG I VARUKORGEN …). Spärren gäller som
         förut: utan alla val går inget i korgen. Tryck på baren innan storleken är
         vald = samma som på köpknappen, så storleksvalet lägger varan i korgen direkt.
         Produkter utan val (en variant) berörs inte. */
      initStickyPick() {
        if (this.getAttribute('data-atc-text') !== 'sticky') return;
        if (!this.skin.querySelector('.on-vp__group')) return;
        this.stickyPick = true;
        if (!this.pickText) this.pickText = this.getAttribute('data-size-pick') || 'Choose a size';
        /* Trycket på baren tas emot av assets/on-sticky-slim.js (window, fångstfas)
           och lämnas hit till onStickyClick. */
        var self = this;
        [0, 600, 1500].forEach(function (ms) { setTimeout(function () { self.paintSticky(); }, ms); });
      }

      paintSticky() {
        if (!this.stickyPick) return;
        this.setAtcPrompt(!!(this.sizeGate || (this.bogoGate && !this.bogoReady())));
      }

      onStickyClick(e) {
        var btn = e.target.closest && e.target.closest('sticky-add-to-cart button, sticky-add-to-cart .sticky-add-to-cart__button');
        if (!btn) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (this.sizeGate) { this.flashSize(); return; }
        /* BOGO: samma knuff som köpknappen, på första gruppen som saknas. */
        if (this.isBogo && !this.bogoReady()) { this.nudgeUnset(); return; }
        var mal = this.sizeGroup || this.skin;
        try { mal.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { mal.scrollIntoView(); }
      }

      /* Hitta native-radio för (fieldsetIndex, value) och välj den nativt. */
      selectNative(fieldsetIndex, value) {
        var inputs = this.engine.querySelectorAll('input[type="radio"][data-fieldset-index="' + fieldsetIndex + '"]');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === value) {
            if (inputs[i].checked) {
              /* Omgång 82 (mätt i live och arbetskopian): utan ?variant= i länken lämnar Horizon
                 formulärets variant-id tomt tills en variant väljs. Väljer kunden det värde som
                 redan är ikryssat i bakgrunden (första varianten, t.ex. XS på WFP, S på PRO) blev
                 det ingen change-händelse, id förblev tomt och köpet gav "Cart Error". Då skickas
                 change ändå, så att Horizon sätter variant-id. */
              var sek = this.section || this.closest('.shopify-section') || document;
              var idf = sek.querySelector('product-form-component input[name="id"]');
              if (idf && !idf.value) inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
            inputs[i].checked = true;
            inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
      }

      onClick(e) {
        /* Knuffens egna knappar forst: de ligger i samma skin men ar inga
           variantval, och traffas aldrig av kontrollen nedanfor. */
        if (e.target.closest('[data-on-szn-go], [data-on-szn-close]')) { this.onNudgeClick(e); return; }

        var trigger = e.target.closest('[data-dd-trigger]');
        if (trigger) { this.toggleMenu(trigger, true); return; }

        /* Dam/herr på första paret: till den andra produkten med samma val. Länken
           fungerar som den är; vi lägger bara till varianten om den finns. */
        var gxGo = e.target.closest('[data-vp-gx-go]');
        if (gxGo) {
          /* Bara när allt är valt: en ?variant= med en gissad storlek skulle hoppa
             över storleksspärren på nästa sida. */
          var cur = this.currentMainValues();
          var allt = cur.length > 0 && cur.every(function (x) { return x != null; });
          var v = allt ? this.resolveVariant(cur, this.altVariants) : null;
          if (v && v.id) {
            e.preventDefault();
            var u = new URL(gxGo.getAttribute('href'), location.href);
            u.searchParams.set('variant', v.id);
            location.href = u.toString();
          }
          return;
        }

        var opt = e.target.closest('.on-variant-option');
        if (!opt) return;

        var fi = opt.getAttribute('data-fieldset-index');
        var val = opt.getAttribute('data-value');
        if (fi === null || val === null) return;

        this.optionClicks = (this.optionClicks || 0) + 1;
        /* INP (omgång 52): valet markeras i bildrutans början (requestAnimationFrame, samma
           uppritning som förut), inte i själva trycket. Andra lyssnare på samma klick
           (Shopifys pixelinsamlare, Meta-pixeln) mäter sidan efter oss, och med klasserna
           redan bytta fick de räkna om hela layouten: upp till 170 ms extra, mätt. */
        var self = this;
        requestAnimationFrame(function () {
          // Ett klick i storleksgruppen häver spärren – därefter beter sig allt som vanligt.
          if (self.sizeGate && self.sizeGroup && self.sizeGroup.contains(opt)) self.resolveSizeGate();
          /* Sparren haves per grupp, inte for hela valjaren: farg vald betyder inte
             att storlek ar vald. */
          var bgrp = opt.closest('.on-vp__group');
          if (bgrp && bgrp.hasAttribute('data-bogo-unset')) bgrp.removeAttribute('data-bogo-unset');
          // Markera aktiv i skin (snabb feedback); native bekräftar via event.
          /* Egen rakning for storlek. Gruppen hittas via data-type, inte via
             this.sizeGroup: den sistnamnda sätts bara när spärrläget är på. */
          if (opt.closest('.on-vp__group[data-type="size"]')) self.countSizePick(val);
          self.setActive(fi, val);
          self.updatePre(opt);
          self.updateFitRow();
          var dd = opt.closest('.on-vp__dd');
          if (dd) self.closeMenu(dd);
          /* INP (prestanda 2026-10-15): valet målas först, resten körs efter nästa bildruta.
             selectNative startar temats variantbyte (hämtning + omritning av sektionen) och
             tredjepartsappar reagerar på sidändringarna; uppmätt 240-290 ms i samma tryck. */
          setTimeout(function () {
            self.selectNative(fi, val);
            self.updateBogoGate();
            self.updateUrgency();
            self.updateCtaTotal();
            self.updateSaveText();
            self.firePending(true);
          }, 0);
        });
      }

      /* Förbeställningsrutan (omgång 54): synlig bara när alla varianter som stämmer med
         valet är förbeställning (flaggan "pre", räknad i Liquid). Storlek ännu ej vald =
         alla storlekar i vald färg. Det tryckta valet står still: flyttas det när rutan
         visas eller döljs skrollas sidan lika mycket tillbaka. */
      /* Passformsraden (omgång 55): tabellens mått för vald storlek, med tabellens rubriker.
         Bara siffror ur tabellen; tum räknas om från cm när besökaren har tum (window.onUnits).
         Ingen storlek vald = hopfälld rad. */
      updateFitRow() {
        var row = this.querySelector('[data-vp-fitrow]');
        if (!row) return;
        if (!this._fitData) {
          try { this._fitData = JSON.parse((row.querySelector('[data-fitrow-data]') || {}).textContent || 'null'); } catch (e) { this._fitData = null; }
          if (!this._fitUnits) {
            var selfF = this;
            this._fitUnits = function () { selfF.updateFitRow(); };
            document.addEventListener('on:units', this._fitUnits);
          }
        }
        var d = this._fitData, t = row.querySelector('[data-fitrow-t]');
        var sg = this.sizeGroup || this.skin.querySelector('.on-vp__group[data-type="size"]');
        var a = sg && sg.querySelector('.on-variant-option.is-active');
        var lab = a ? String(a.getAttribute('data-value') || '').trim() : '';
        var vals = d && d.rows && lab ? d.rows[lab.toUpperCase().replace(/\s+/g, '')] || d.rows[lab.toUpperCase()] : null;
        var imp = !!(window.onUnits && window.onUnits.get && window.onUnits.get() === 'imperial');
        var en = /^en/i.test(document.documentElement.lang || '');
        var parts = [];
        if (vals) {
          for (var i = 0; i < d.cols.length; i++) {
            var v = String(vals[i] == null ? '' : vals[i]).trim();
            if (!v || !/\d/.test(v)) continue;
            if (imp) v = v.replace(/\d+(?:[.,]\d+)?/g, function (n) { var x = parseFloat(n.replace(',', '.')) / 2.54; return String(Math.round(x * 10) / 10); });
            /* Decimaltecknet efter språket: komma överallt utom på engelska. */
            if (!en) v = v.replace(/(\d)\.(\d)/g, '$1,$2');
            var mn = (row.getAttribute('data-m') || '').split('|');
            var mi = ['waist', 'hip', 'bust', 'leg', 'len', 'foot'].indexOf(d.cols[i]);
            var name = mi > -1 && mn[mi] ? mn[mi] : '';
            if (!name) continue;
            parts.push((name + ' ' + v).replace(/ /g, '\u00a0') + '\u00a0' + (imp ? 'in' : 'cm'));
          }
        }
        /* Omgång 56: Kroppslängd (standard) eller måtten. Texterna i fallande längd; den första
           som ryms på en rad visas (__onFitLine). */
        var texts = [];
        var hr = (row.getAttribute('data-mode') || 'height') === 'height' && lab ? __onFitHeight(d, lab) : null;
        if (hr) {
          var ftin = function (cm) { var x = Math.round(cm / 2.54); return Math.floor(x / 12) + '\u2032' + (x % 12) + '\u2033'; };
          var hs = imp ? (ftin(hr[0]) + (hr[1] > hr[0] ? '\u2013' + ftin(hr[1]) : ''))
            : (hr[0] + (hr[1] > hr[0] ? '\u2013' + hr[1] : '') + '\u00a0cm');
          [row.getAttribute('data-ht'), row.getAttribute('data-ht-s'), '[s] \u00b7 [h]'].forEach(function (tp) {
            if (tp) texts.push(tp.split('[s]').join(lab).split('[h]').join(hs));
          });
        } else if (parts.length) {
          var lead = (row.getAttribute('data-lead') || '[s]').split('[s]').join(lab);
          texts.push(lead + ' ' + parts.join(' \u00b7 '));
          texts.push(lab + ': ' + parts.join(' \u00b7 '));
          if (parts.length > 2) texts.push(lab + ': ' + parts.slice(0, 2).join(' \u00b7 '));
          if (parts.length > 1) texts.push(lab + ': ' + parts[0]);
        }
        /* Omgång 57: har kunden gjort quizet och valt den rekommenderade storleken talar raden
           om vad quizet kom fram till (längden för just henne, Mudd), i stället för intervallet.
           Annan storlek eller inget quiz: som förut. */
        var url = ((this.engine && this.engine.getAttribute('data-product-url')) || '').split('?')[0];
        var qf = lab ? __onQuizFit(url.split('/').pop()) : null;
        var norm = function (x) { return String(x || '').toUpperCase().replace(/\s+/g, ''); };
        if (qf && norm(qf.s) === norm(lab)) {
          var cuffBtn = null;
          var sts = this.skin.querySelectorAll('.on-vp__group[data-type="other"] .on-variant-option');
          for (var ci = 0; ci < sts.length; ci++) if (__onCuffRe.test(String(sts[ci].getAttribute('data-value') || '').trim())) { cuffBtn = sts[ci]; break; }
          var cn = cuffBtn ? String(cuffBtn.getAttribute('data-value')).trim() : '';
          var body = '';
          if (qf.long && cuffBtn) body = (cuffBtn.classList.contains('is-active') ? row.getAttribute('data-fq-cuff-on') : row.getAttribute('data-fq-long-cuff')) || '';
          else if (qf.long) body = row.getAttribute('data-fq-long') || '';
          else if (qf.short) body = row.getAttribute('data-fq-short') || '';
          else if (qf.h) body = row.getAttribute('data-fq-ok') || '';
          body = body.split('[c]').join(cn);
          var pre = row.getAttribute('data-fq-pre') || '';
          texts = body ? [pre + ' ' + body, body] : [pre];
        }
        var on = texts.length > 0;
        /* INP: skriv i befintlig textnod (__onTxt), inte textContent (omgång 52). */
        if (t) __onFitLine(t, texts);
        if (row.classList.contains('is-on') !== on) row.classList.toggle('is-on', on);
      }

      updatePre(anchor) {
        var box = this.querySelector('[data-vp-pre]');
        if (!box) return;
        var vals = this.currentMainValues();
        var cand = (this.vpVariants || []).filter(function (v) {
          /* En slutsåld storlek är aldrig förbeställning och räknas inte (som i Liquid). */
          if (v.av === false) return false;
          for (var k = 0; k < vals.length; k++) { if (vals[k] != null && (v.o[k] || '') !== vals[k]) return false; }
          return true;
        });
        var show = cand.length > 0 && cand.every(function (v) { return v.pre; });
        if (box.hidden === !show) return;
        var a = anchor && anchor.isConnected ? anchor : null;
        var t0 = a ? a.getBoundingClientRect().top : 0;
        box.hidden = !show;
        if (a) {
          var d = a.getBoundingClientRect().top - t0;
          if (Math.abs(d) > 0.5) window.scrollBy(0, d);
        }
      }

      /* Dam/herr på färgraden: ryms raden inte (smal kolumn) döljs färgnamnet. */
      fitGenderMain() {
        var gx = this.skin && this.skin.querySelector('[data-vp-gx-main]');
        if (!gx) return;
        var lab = gx.parentElement;
        lab.classList.remove('is-gx-tight');
        var lr = lab.getBoundingClientRect(), gr = gx.getBoundingClientRect();
        if (gr.right > lr.right + 1 || lab.scrollWidth > lab.clientWidth + 1) lab.classList.add('is-gx-tight');
      }

      /* ── Köp direkt efter valet (omgång 34) ───────────────────────────────
         Trycker kunden på köpknappen innan allt är valt stoppas köpet som förut,
         men försöket kommer vi ihåg. När sista valet sedan görs läggs produkten i
         korgen direkt, så kunden slipper trycka på köpknappen en gång till.
         Huvudväljarens val byter Shopifys variant (sektionen ritas om), så vi
         väntar på variant:update innan knappen trycks; kommer ingen händelse
         (samma variant) trycks den efter en kort stund ändå. Försöket gäller i
         två minuter.
         AVSTÄNGT (Victor, omgång 41): kunden ska alltid trycka på köpknappen själv.
         Ett tryck före valen lade annars varan i korgen när storleken väl valdes,
         utan att kunden tryckt igen. Funktionen finns kvar som tomt anrop, så att
         spärren och knuffen fungerar som förut. */
      armPending() {
        this._pending = 0;
      }

      firePending(fromMain) {
        if (!this._pending) return;
        if (Date.now() - this._pending > 120000) { this._pending = 0; return; }
        if (this.sizeGate || (this.isBogo && !this.bogoReady())) return;
        this._pending = 0;
        var self = this;
        var done = false;
        var go = function () {
          if (done) return;
          done = true;
          document.removeEventListener('variant:update', onUpd);
          var scope = self.section || self.closest('.shopify-section') || document;
          var btns = Array.prototype.slice.call(scope.querySelectorAll('button[name="add"]'));
          var btn = btns.filter(function (b) { return !b.closest('sticky-add-to-cart'); })[0] || btns[0];
          if (btn && !btn.disabled) btn.click();
        };
        var onUpd = function () { setTimeout(go, 150); };
        if (fromMain) {
          document.addEventListener('variant:update', onUpd);
          setTimeout(go, 1200);
        } else {
          setTimeout(go, 60);
        }
      }

      onDocClick(e) {
        if (this.contains(e.target)) return;
        this.querySelectorAll('.on-vp__dd-trigger[aria-expanded="true"]').forEach((t) => {
          this.toggleMenu(t, false);
        });
      }

      toggleMenu(trigger) {
        var dd = trigger.closest('.on-vp__dd');
        if (!dd) return;
        var menu = dd.querySelector('.on-vp__dd-menu');
        var open = trigger.getAttribute('aria-expanded') !== 'true';
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (menu) menu.hidden = !open;
      }

      closeMenu(dd) {
        var trigger = dd.querySelector('.on-vp__dd-trigger');
        var menu = dd.querySelector('.on-vp__dd-menu');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu) menu.hidden = true;
      }

      setActive(fi, val) {
        var group = this.skin.querySelector('.on-vp__group[data-fieldset-index="' + fi + '"]');
        this.markGroup(group, val);
      }

      /* Markera vald option + uppdatera etikett/swatch i EN grupp (huvudväljare ELLER par-klon). */
      /* "XS" → "XS • 44" i etiketten ovanför knapparna. Kartan ligger på gruppen
         (data-alt-map) och kommer från produktens egen storleksguide, så JS gissar
         aldrig fram en siffra – finns den inte visas bara bokstaven. */
      labelWithAlt(group, val) {
        if (!group || !val) return val;
        var where = group.getAttribute('data-alt-where');
        if (where !== 'label' && where !== 'both') return val;
        var map = group.getAttribute('data-alt-map');
        if (!map) return val;
        var sep = group.getAttribute('data-alt-sep') || '•';
        var key = String(val).toUpperCase().replace(/\s+/g, '');
        var parts = map.split('|');
        for (var i = 1; i < parts.length; i++) {
          var kv = parts[i].split('=');
          if (kv.length === 2 && kv[0] === key) return val + ' ' + sep + ' ' + kv[1];
        }
        return val;
      }

      markGroup(group, val) {
        if (!group) return;
        // Native-motorn har alltid en storlek vald internt. Så länge spärren gäller
        // får den inte måla tillbaka XS som aktiv, då vore "ingen förvald" bara på pappret.
        if (this.sizeGate && group === this.sizeGroup) return;
        /* En grupp som vantar pa kundens val far inte malas av native-motorns
           atermalning. Utan detta skrev Shopifys "forsta tillgangliga variant"
           tillbaka sig sjalv och valet sag gjort ut fast ingen tryckt. */
        if (group && group.hasAttribute && group.hasAttribute('data-bogo-unset')) return;
        group.querySelectorAll('.on-variant-option').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-value') === val);
        });
        var shown = this.labelWithAlt(group, val);
        var curText = group.querySelector('[data-current-text]');
        if (curText) __onTxt(curText, shown);
        var ddText = group.querySelector('[data-dd-current-text]');
        if (ddText) __onTxt(ddText, shown);
        var activeBtn = group.querySelector('.on-variant-option.is-active');
        if (activeBtn) {
          var src = activeBtn.querySelector('.on-swatch');
          if (src) {
            // Kopiera BARA färgen (data-hex) – inte hela elementet. Klonades förut, vilket drog med sig
            // knappens storlek (30px) in i den lilla indikatorpricken (14px) så den såg fel ut.
            var hex = src.getAttribute('data-hex');
            group.querySelectorAll('.on-vp__current .on-swatch, .on-vp__dd-current .on-swatch').forEach(function (dst) {
              if (hex) { dst.style.background = hex; dst.setAttribute('data-hex', hex); }
            });
          }
        }
      }

      /* Resync skin från native-motorn efter temats variant:update. */
      onVariantUpdate() {
        var fieldsets = this.engine.querySelectorAll('.on-vp-engine__fieldset');
        fieldsets.forEach((fs) => {
          var fi = fs.getAttribute('data-fieldset-index');
          var checked = fs.querySelector('input[type="radio"]:checked, input[data-current-checked="true"]');
          if (checked) this.setActive(fi, checked.value);
          // Spegla tillgänglighet
          var group = this.skin.querySelector('.on-vp__group[data-fieldset-index="' + fi + '"]');
          if (!group) return;
          fs.querySelectorAll('input[type="radio"]').forEach((inp) => {
            var btn = group.querySelector('.on-variant-option[data-value="' + (window.CSS && CSS.escape ? CSS.escape(inp.value) : inp.value) + '"]');
            if (btn) btn.classList.toggle('is-unavailable', inp.getAttribute('data-option-available') === 'false');
          });
        });
        this.updatePre();
        this.updateFitRow();
        // Temat renderar om köpknappen vid variantbyte, så uppmaningen måste sättas tillbaka
        // så länge storleken fortfarande är ovald (t.ex. när kunden byter färg först).
        if (this.sizeGate) this.setAtcPrompt(true);
        if (this.bogoGate && !this.bogoReady()) this.setAtcPrompt(true);
        /* Baren ritas om av sin egen komponent efter variantbytet: sätt tillbaka uppmaningen. */
        if (this.stickyPick) { var selfS = this; this.paintSticky(); [150, 500].forEach(function (ms) { setTimeout(function () { selfS.paintSticky(); }, ms); }); }
        this.updateUrgency();
        this.updateB2Imgs();
        this.fitGenderMain();
      }

      /* Lagernotis – SAMMA funktion som Paket/bundle (ON): deterministisk per variant-ID (FNV-1a),
         bara en delmängd av varianterna visar lappen, antal 5–28 fast per variant. Butiken översäljer
         → äkta saldo används inte. Visas först efter N klick på varianterna (inställning). */
      updateUrgency() {
        var low = this.querySelector('[data-low]');
        if (!low) return;
        var v = (this.vpVariants && this.vpVariants.length) ? this.resolveVariant(this.rowValues(this.skin)) : null;

        /* Bestam forst OM lagernotisen ("Endast N kvar") galler. Gor den inte det
           lamnas raden inte tom langre: da star "Finns i lager, redo att skickas"
           dar i stallet, sa besokaren alltid ser ett lagerbesked. */
        var showLow = false, n = 0;
        if (v && this.getAttribute('data-urgency') === 'true' &&
            (this.optionClicks || 0) >= (this.stockAfter || 0)) {
          var h = this.hashId(v.id);                 // deterministisk delmangd (~55%)
          if ((h % 100) < 55) { showLow = true; n = 5 + ((h >>> 7) % 24); } // 5..28, fast per variant
        }

        if (showLow) {
          low.className = 'on-vp__low' + (this.stockDot === 'pulse' ? ' on-vp__low--pulse' : '');
          low.style.setProperty('--on-vp-stock-dot', this.stockDotColor || '#f46245');
          low.style.setProperty('--on-vp-stock-text', this.stockTextColor || '#111');
          var dotHtml = (this.stockDot === 'none') ? '' : '<span class="on-vp__low-dot"></span>';
          low.innerHTML = dotHtml + '<span class="on-vp__low-text"></span>';
          low.querySelector('.on-vp__low-text').textContent =
            (this.getAttribute('data-upre') || '') + ' ' + n + ' ' + (this.getAttribute('data-upost') || '');
          low.hidden = false;
          return;
        }

        /* "Finns i lager" pulserar pa samma villkor som "Endast N kvar" - inställningen
           Punkt sager att pricken ska pulsera, oavsett vilket besked raden bar. */
        if (!this.readyTxt || !v || !v.av) { low.hidden = true; return; }
        low.className = 'on-vp__low on-vp__low--ready' + (this.stockDot === 'pulse' ? ' on-vp__low--pulse' : '');
        low.style.setProperty('--on-vp-stock-dot', this.readyDotColor || '#1E7A3C');
        low.style.setProperty('--on-vp-stock-text', this.stockTextColor || '#111');
        low.innerHTML = (this.stockDot === 'none' ? '' : '<span class="on-vp__low-dot"></span>') +
          '<span class="on-vp__low-text"></span>';
        __onTxt(low.querySelector('.on-vp__low-text'), this.readyTxt);
        low.hidden = false;
      }
      /* ── "Lägg till fler par"-remsa (valfritt bundle-läge) ── */
      initMulti() {
        this.multi = this.querySelector('[data-vp-multi]');
        if (!this.multi) return;
        this.extrasEl = this.multi.querySelector('[data-vp-extras]');
        this.addBtn = this.multi.querySelector('[data-vp-add]');
        this.pairTpl = this.querySelector('template[data-vp-pair-tpl]');
        this.maxPairs = parseInt(this.getAttribute('data-max-pairs') || '3', 10) || 3;
        this.cartAddUrl = this.getAttribute('data-cart-add') || '/cart/add.js';
        this.pairWord = this.getAttribute('data-pair-word') || 'Pair';
        this.inStockTxt = this.getAttribute('data-instock') || '';
        this.soldOutTxt = this.getAttribute('data-soldout') || '';
        this.lowStockTxt = this.getAttribute('data-lowstock') || '';
        this.section = this.closest('.shopify-section') || document;
        try { this.vpVariants = JSON.parse((this.querySelector('[data-vp-variants]') || {}).textContent || '[]'); } catch (e) { this.vpVariants = []; }
        this.saveEl = this.multi.querySelector('[data-vp-save]');
        this.saveTmpl = this.getAttribute('data-save-tmpl') || '';
        this.unitEl = this.multi.querySelector('[data-vp-unit]');
        this.unitWasEl = this.multi.querySelector('[data-vp-unit-was]');
        /* 'total' = rutan visar vad HELA kopet kostar vid nasta antal i stallet
           for vad ETT plagg gar pa. BOGO har alltid totalen: 'styckpris' pa ett
           erbjudande dar andra plagget ar gratis beskriver fel sak. */
        this.priceMode = this.getAttribute('data-price-mode') || 'unit';
        this.unitTmpl = this.getAttribute('data-unit-tmpl') || '';
        this.totalTmpl = this.getAttribute('data-total-tmpl') || '';
        this.isBogo = this.getAttribute('data-bogo') === '1';
        this.saveMode = this.getAttribute('data-save-mode') || 'percent';
        this.saveAmtTmpl = this.getAttribute('data-save-amt-tmpl') || '';
        this.saveBuyTmpl = this.getAttribute('data-save-buy-tmpl') || '';
        this.saveBuyKind = this.getAttribute('data-save-buy-kind') || 'extra';
        this.saveBuyTmplS = this.getAttribute('data-save-buy-tmpl-s') || '';
        /* parseFloat, INTE parseInt. Produktegna trappor ar byggda runt prispunkter
           (Warm Fleece Pants: 2-pack 1 199 kr = 33,32 %), och kapas decimalerna bort
           landar totalen 6 kr fel mot kassan. */
        this.t2 = parseFloat(this.getAttribute('data-tier2') || '0') || 0;
        this.t3 = parseFloat(this.getAttribute('data-tier3') || '0') || 0;
        this.t4 = parseFloat(this.getAttribute('data-tier4') || '0') || 0;

        var self = this;
        if (this.addBtn) this.addBtn.addEventListener('click', function () { self.addPair(); });
        // Klick i par-raderna: ta bort / öppna dropdown / välj variant (samma proxy som huvudväljaren).
        this.multi.addEventListener('click', function (e) {
          /* Designen "Rader": raden fälls ut / paret läggs till. */
          if (e.target.closest('[data-vpr-toggle]')) { self.rowsToggle(); return; }
          var cf = e.target.closest('[data-vpr-confirm]');
          if (cf) { if (!cf.disabled) self.rowsConfirm(); return; }
          /* Omgång 49: ännu ett par i samma ruta. */
          if (e.target.closest('[data-vpr-more]')) { self.addPair(self.rowsStage()); self.rowsReady(); return; }
          /* Dam/Herr-vaxlaren. Ligger forst: den ar ingen variantknapp och
             far inte falla igenom till variantproxyn nedan. */
          var gx = e.target.closest('[data-vp-gender]');
          if (gx) {
            var grow = gx.closest('[data-vp-pair]');
            if (grow) {
              grow.setAttribute('data-gender', gx.getAttribute('data-vp-gender'));
              grow.querySelectorAll('[data-vp-gender]').forEach(function (b) { b.classList.toggle('is-active', b === gx); });
              /* Lagerstatus, bilder och total raknas om mot den NYA produktens
                 varianter. Valen star kvar: bada produkterna har samma
                 optionsvarden. */
              self.applyPairImages(grow);
              self.updateB2Imgs();
              self.updatePairStock(grow);
              self.updateCtaTotal();
            }
            return;
          }
          var rm = e.target.closest('[data-vp-remove]');
          if (rm) {
            var r = rm.closest('[data-vp-pair]');
            if (r) {
              r.remove();
              var st0 = self.rowsStage();
              if (st0 && !st0.querySelector('[data-vp-pair]') && !st0.closest('[data-vpr-body]').hidden) self.rowsToggle(false);
              else { self.renumber(); self.rowsReady(); }
            }
            return;
          }
          var row = e.target.closest('[data-vp-pair]');
          if (!row) return;
          var trig = e.target.closest('.on-vp__dd-trigger');
          if (trig) { self.toggleMenu(trig); return; }
          var opt = e.target.closest('.on-variant-option');
          if (!opt) return;
          var fi = opt.getAttribute('data-fieldset-index');
          var val = opt.getAttribute('data-value');
          if (fi === null || val === null) return;
          var pg = row.querySelector('.on-vp__group[data-fieldset-index="' + fi + '"]');
          if (pg && pg.hasAttribute('data-bogo-unset')) pg.removeAttribute('data-bogo-unset');
          self.markGroup(pg, val);
          var dd = opt.closest('.on-vp__dd'); if (dd) self.closeMenu(dd);
          self.updatePairStock(row);
          self.updateCtaTotal();
          self.updateBogoGate();
          self.updateB2Imgs();
          self.rowsReady();
          self.firePending(false);
        });

        // Horizon renderar om produktsektionen vid varje variantbyte. Da kommer
        // serverns styckpris tillbaka i knappen och vart pakettotal skrivs over -
        // darav att priset ibland stamde och ibland inte. Vi skriver tillbaka det
        // efter varje variantuppdatering.
        this._onVariantUpd = function () { setTimeout(function () { self.updateCtaTotal(); self.updateSaveText(); self.rowsRefresh(); }, 60); };
        document.addEventListener('variant:update', this._onVariantUpd);
        this._onAtc = this.onAtcClick.bind(this);
        document.addEventListener('click', this._onAtc, true);
        this.updateSaveText();

        // Forvalt antal extra par: 1 = paketet ligger oppet som 2-pack redan vid
        // sidladdning. Kunden kan fortfarande ta bort raden, sa inget lases.
        /* BOGO: bada plaggen ligger uppslagna fran borjan. Att val nummer tva
           lag bakom en knapp var hela orsaken till felbestallningarna - kunder
           la i ETT plagg och trodde att det andra foljde med automatiskt.
           Knappen doljs, och krysset likasa (CSS): erbjudandet ar tva plagg. */
        var startPairs = parseInt(this.getAttribute('data-start-pairs') || '0', 10) || 0;
        if (this.isBogo) {
          startPairs = 1;
          this.bogoItem = this.getAttribute('data-bogo-item') || 'Item';
          this.bogoFree = this.getAttribute('data-bogo-free') || 'FREE';
          if (this.addBtn) this.addBtn.hidden = true;
          this.multi.classList.add('on-vp-multi--bogo');
          /* BOGO V2: kortdesignen (omgang 33). Kort 2 far rubriken "Ditt
             gratispar", GRATIS-markning och bilden pa vald variant. */
          this.isB2 = this.classList.contains('on-vp--b2');
          this.b2Free = this.getAttribute('data-b2-free') || '';
        }
        if (startPairs > 0) {
          var wanted = Math.min(startPairs, this.maxPairs);
          for (var sp = 0; sp < wanted; sp++) this.addPair();
        }
        this.initRows();
      }

      currentMainValues() {
        var vals = [];
        this.skin.querySelectorAll('.on-vp__group').forEach(function (g) {
          var fi = parseInt(g.getAttribute('data-fieldset-index'), 10);
          var a = g.querySelector('.on-variant-option.is-active');
          vals[fi] = a ? a.getAttribute('data-value') : null;
        });
        return vals;
      }

      addPair(into) {
        if (!this.pairTpl || !this.extrasEl) return;
        if (this.allPairs().length >= this.maxPairs) return;
        /* into = radlägets utfällda yta "Ett par till". Sedan omgång 49 räknas paret
           där direkt (allPairs): priset i köpknappen följer med och köpknappen
           lägger det i korgen. Ingen Lägg till-knapp och ingen egen ruta. */
        var target = into || this.extrasEl;
        var self = this;
        var frag = this.pairTpl.content.cloneNode(true);
        var row = frag.querySelector('[data-vp-pair]');
        var opts = row.querySelector('[data-vp-opts]');
        var main = this.currentMainValues();
        // Klona huvudväljarens option-grupper → EXAKT samma design/typsnitt (swatchar/storleksrutnät/pills).
        this.skin.querySelectorAll('.on-vp__group').forEach(function (g) {
          var clone = g.cloneNode(true);
          clone.querySelectorAll('.on-vp__dd-trigger[aria-expanded="true"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
          clone.querySelectorAll('.on-vp__dd-menu').forEach(function (m) { m.hidden = true; });
          // Storleks-spärren gäller BARA huvudväljaren. Klonas attributet med hit
          // fortsätter köpknappen att se låst ut även efter att storleken valts,
          // eftersom ingen häver spärren på en kopia.
          clone.removeAttribute('data-unchosen');
          /* Storlekshjalpen och quizbannern hor till HUVUDVALJAREN. De lag i
             storleksgruppen och foljde darfor med varje klon, sa plagg 2 fick
             en egen "Hitta min storlek" och en egen banner. Quizet galler
             produkten, inte raden, sa kopiorna sa bara samma sak en gang till. */
          clone.querySelectorAll('.on-vp__sizehelp, .on-sqbn, .on-sqline, .on-fitrow').forEach(function (n) { n.remove(); });
          if (opts) opts.appendChild(clone);
          var fi = parseInt(clone.getAttribute('data-fieldset-index'), 10);
          /* BOGO forvaljer INGENTING. Kopierades huvudvalet in sag plagg 2 redan
             ifyllt ut, och kunden bekraftade ett val hen aldrig gjort - exakt
             det missforstand vi ar har for att ratta. */
          if (self.isBogo) { self.clearGroup(clone); clone.setAttribute('data-bogo-unset', ''); }
          else if (main[fi] != null) self.markGroup(clone, main[fi]);
        });
        /* Dam/herr: extra paret har sin växel i radens rubrik (bredvid "Byxor #2"),
           huvudväljarens växel på färgraden följer inte med i kopian (omgång 34). */
        if (opts) opts.querySelectorAll('[data-vp-gx-main]').forEach(function (n) { n.remove(); });
        /* Omgång 45/47: i "Ett par till" (radläget) och BOGO (V1 och V2) står parets
           växel på FÄRG-raden, till höger, precis som huvudväljarens. Lägg till fler
           par i övriga designer behåller den i radens rubrik. */
        var gxp = row.querySelector('.on-vp-pair__bar .on-vp-pair__gx');
        var fargRad = opts && opts.querySelector('.on-vp__group--color .on-vp__label');
        if (gxp && fargRad && (into || this.isBogo)) {
          gxp.classList.add('on-vp-pair__gx--label');
          fargRad.appendChild(gxp);
        }
        target.appendChild(frag);
        if (window.onFitSizes) setTimeout(window.onFitSizes, 0);
        this.renumber();
        this.updatePairStock(target.lastElementChild);
      }

      renumber() {
        var rows = this.extrasEl ? this.extrasEl.querySelectorAll('[data-vp-pair]') : [];
        var self = this;
        Array.prototype.forEach.call(rows, function (row, i) {
          var no = row.querySelector('.on-vp-pair__no');
          if (!no) return;
          if (!self.isBogo) {
            __onTxt(no, self.pairWord + ' #' + (i + 2));
            if (self.rowsEl) {
              var sum = self.rowValues(row).filter(function (x) { return x != null; }).join(' · ');
              if (sum) no.textContent += ' · ' + sum;
            }
            return;
          }
          if (self.isB2) {
            if (no.querySelector('.on-vp-b2__name')) return;
            __onTxt(no, '');
            var nm = document.createElement('span');
            nm.className = 'on-vp-b2__name';
            __onTxt(nm, self.b2Free);
            var tg = document.createElement('span');
            tg.className = 'on-vp-b2__tag on-vp-b2__tag--free';
            __onTxt(tg, self.bogoFree);
            no.appendChild(nm);
            no.appendChild(tg);
            no.classList.add('on-vp-b2__ttl');
            var bar = row.querySelector('.on-vp-pair__bar');
            var main = self.querySelector('[data-vp-b2-img]');
            if (bar && main && !bar.querySelector('[data-vp-b2-img]')) {
              var im = main.cloneNode(false);
              im.removeAttribute('srcset');
              im.removeAttribute('sizes');
              bar.appendChild(im);
            }
            return;
          }
          /* "Plagg 2 GRATIS", inte "Par #2". Siffran i ringen speglar ettan over
             forsta valjaren, sa de tva stegen laser sig som en serie. */
          __onTxt(no, '');
          var ring = document.createElement('span');
          ring.className = 'on-vp-bogo__step-n';
          __onTxt(ring, String(i + 2));
          no.appendChild(ring);
          no.appendChild(document.createTextNode(' ' + self.bogoItem + ' ' + (i + 2)));
          var pill = document.createElement('span');
          pill.className = 'on-vp-bogo__free';
          __onTxt(pill, self.bogoFree);
          no.appendChild(pill);
          no.classList.add('on-vp-bogo__step');
        });
        if (this.addBtn) this.addBtn.style.display = (this.isBogo || rows.length >= this.maxPairs) ? 'none' : '';
        this.placeStockLast();
        this.updateSaveText();
        this.updateCtaTotal();
        this.updateB2Imgs();
        this.rowsRefresh();
      }

      /* ── Designen "Rader" (omgång 34, Victors bild 4) ─────────────────────
         Raden "Ett par till" fälls ut; paret väljs i den utfällda ytan och
         räknas först när kunden trycker "Lägg till" (då flyttas det till
         extrasEl och visas som en kompakt rad med kryss). Tilläggen blir rader
         som fälls ut med plusset. Priset på raden är styckpriset för nästa par
         efter mängdrabatten, samma tal som knappen visar. */
      /* Alla extra par som ingår i köpet: de i extrasEl och, i radläget, paren i den
         utfällda rutan "Ett par till" (omgång 49: de räknas så fort rutan är öppen). */
      allPairs() {
        var ut = [];
        if (this.extrasEl) this.extrasEl.querySelectorAll('[data-vp-pair]').forEach(function (r) { ut.push(r); });
        var st = this.rowsStage();
        if (st) st.querySelectorAll('[data-vp-pair]').forEach(function (r) { ut.push(r); });
        return ut;
      }

      /* Grupper i de extra paren som saknar val. */
      pairsUnset() {
        var ut = [];
        this.allPairs().forEach(function (r) {
          r.querySelectorAll('.on-vp__group').forEach(function (g) { if (!g.querySelector('.on-variant-option.is-active')) ut.push(g); });
        });
        return ut;
      }

      /* Saknas ett val i ett par händer ingenting vid köp: valet markeras som på
         huvudväljaren (samma knuff, data-nudge) och sidan rullar dit. */
      nudgePairs() {
        var kvar = this.pairsUnset();
        if (!kvar.length) return false;
        kvar.forEach(function (g) {
          g.setAttribute('data-bogo-unset', '');
          g.setAttribute('data-nudge', '');
          setTimeout(function () { g.removeAttribute('data-nudge'); }, 900);
        });
        try { kvar[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { kvar[0].scrollIntoView(); }
        return true;
      }

      initRows() {
        this.rowsEl = this.multi ? this.multi.querySelector('[data-vpr]') : null;
        if (!this.rowsEl) return;
        if (this.addBtn) this.addBtn.hidden = true;
        this.rowsRefresh();
      }

      rowsStage() { return this.rowsEl ? this.rowsEl.querySelector('[data-vpr-stage]') : null; }

      /* Raden "Ett par till" visar det utfällda parets bild: färg och dam/herr,
         samma uppslag som BOGO-korten (omgång 39). Ovalda val räknas inte. */
      updateRowsImg() {
        if (!this.rowsEl) return;
        var st = this.rowsStage();
        var row = st && st.querySelector('[data-vp-pair]');
        var img = this.rowsEl.querySelector('.on-vpr__img');
        if (!row || !img) return;
        var url = this.b2ImgFor(this.rowValues(row), row.getAttribute('data-gender') === 'alt');
        if (!url || img.getAttribute('src') === url) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('src', url);
      }

      rowsToggle(force) {
        if (!this.rowsEl) return;
        var body = this.rowsEl.querySelector('[data-vpr-body]');
        var top = this.rowsEl.querySelector('[data-vpr-toggle]');
        var open = typeof force === 'boolean' ? force : body.hidden;
        var stage = this.rowsStage();
        if (open) {
          if (stage && !stage.querySelector('[data-vp-pair]')) this.addPair(stage);
          this.updateRowsImg();
        } else if (stage) {
          stage.innerHTML = '';
        }
        body.hidden = !open;
        top.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) this.renumber();
        this.rowsReady();
      }

      /* Lägg till är aktiv först när varje val i det utfällda paret är gjort. */
      rowsReady() {
        if (!this.rowsEl) return;
        var stage = this.rowsStage();
        var row = stage && stage.querySelector('[data-vp-pair]');
        var btn = this.rowsEl.querySelector('[data-vpr-confirm]');
        if (btn) {
          var ok = !!row && this.rowValues(row).every(function (x) { return x != null; });
          btn.disabled = !ok;
        }
        /* Omgång 49: "+ Ett par till" i rutan så länge fler par får plats, och
           par två och framåt i rutan får nummer och kryss. */
        var more = this.rowsEl.querySelector('[data-vpr-more]');
        if (more) more.hidden = this.allPairs().length >= this.maxPairs;
        var self = this;
        if (stage) stage.querySelectorAll('[data-vp-pair]').forEach(function (r, i) {
          var no = r.querySelector('.on-vp-pair__no');
          if (no) __onTxt(no, self.pairWord + ' #' + (i + 2));
        });
      }

      rowsConfirm() {
        var stage = this.rowsStage();
        var row = stage && stage.querySelector('[data-vp-pair]');
        if (!row) return;
        row.classList.add('is-confirmed');
        this.extrasEl.appendChild(row);
        this.rowsToggle(false);
        this.renumber();
        this.updatePairStock(row);
      }

      rowsRefresh() {
        if (!this.rowsEl) return;
        var nx = this.extrasEl ? this.extrasEl.querySelectorAll('[data-vp-pair]').length : 0;
        var st = this.rowsStage();
        var ns = st ? st.querySelectorAll('[data-vp-pair]').length : 0;
        this.rowsEl.hidden = !ns && nx >= this.maxPairs;
        var mainV = this.resolveVariant(this.rowValues(this.skin)) || (this.vpVariants || [])[0];
        if (!mainV) return;
        /* Öppen ruta: paret ingår redan, raden visar dess styckpris. Stängd: nästa pars. */
        var count = 1 + nx + ns + (ns ? 0 : 1) + (this.addonCount ? this.addonCount() : 0);
        var each = Math.round(mainV.p * (100 - this.pctFor(count)) / 100);
        var txt = this.money(each);
        var pe = this.rowsEl.querySelector('[data-vpr-price]');
        var ce = this.rowsEl.querySelector('[data-vpr-cprice]');
        if (pe) __onTxt(pe, '+' + txt);
        if (ce) __onTxt(ce, txt);
      }


      /* BOGO V2: bilden i varje kort foljer kortets val. Ovalda grupper
         raknas inte, sa en vald farg racker for ratt bild. Dam/herr-vaxeln
         slar upp i den andra produktens varianter. */
      b2ImgFor(vals, alt) {
        var list = (alt ? this.altVariants : this.vpVariants) || [];
        for (var i = 0; i < list.length; i++) {
          var v = list[i], ok = true;
          for (var k = 0; k < vals.length; k++) {
            if (vals[k] != null && v.o && v.o[k] !== vals[k]) { ok = false; break; }
          }
          if (ok && v.i) return v.i;
        }
        return null;
      }

      updateB2Imgs() {
        this.updateRowsImg();
        if (!this.isB2) return;
        var self = this;
        var put = function (img, url) {
          if (!img || !url || img.getAttribute('src') === url) return;
          img.removeAttribute('srcset');
          img.setAttribute('src', url);
        };
        put(this.querySelector('.on-vp-b2__head [data-vp-b2-img]'), this.b2ImgFor(this.rowValues(this.skin), false));
        if (!this.extrasEl) return;
        this.extrasEl.querySelectorAll('[data-vp-pair]').forEach(function (row) {
          var alt = row.getAttribute('data-gender') === 'alt';
          put(row.querySelector('[data-vp-b2-img]'), self.b2ImgFor(self.rowValues(row), alt));
        });
      }

      /* Lagernotisen ska stå på EN plats: längst ned, under sista paret. Utan detta
         hamnar den kvar mellan huvudväljaren och par #2 och läses som att den gäller
         par #2. Flyttas noden i stället för att dubbleras – en sanning, ett element. */
      placeStockLast() {
        var low = this.skin ? this.skin.querySelector('.on-vp__low') : null;
        if (!low || !this.multi) return;
        var hasPairs = this.extrasEl && this.extrasEl.querySelector('[data-vp-pair]');
        if (hasPairs) {
          // Mellan sista parets storlekar och "Lägg till fler" – inte efter knappen.
          low.classList.add('on-vp__low--in-multi');
          if (this.addBtn && this.addBtn.parentElement === this.multi) {
            if (low.nextElementSibling !== this.addBtn) this.multi.insertBefore(low, this.addBtn);
          } else if (low.parentElement !== this.multi) {
            this.multi.appendChild(low);
          }
        } else if (low.parentElement === this.multi && this.skin) {
          low.classList.remove('on-vp__low--in-multi');
          this.skin.appendChild(low);
        }
      }

      /* ── TILLAGGEN I PAKETET ────────────────────────────────────────────
         Ett tillagg ar en rad till i samma paket som de extra paren: det
         summeras i samma total, raknas in i samma rabattrappa och laggs i
         korgen av samma kopknapp. Darfor finns det inget eget kopflode har -
         bara en lista over valda varianter. */
      initAddonBundle() {
        this.addonItems = {};
        if (!this.querySelector('on-fbt[data-bundle="1"]')) return;
        var self = this;
        this._onAddon = function (e) { self.onAddon(e); };
        document.addEventListener('on-vp:addon', this._onAddon);
        /* Avlysningen av kopknappen bor normalt i initMulti, men den avbryter
           tidigt nar par-remsan ar av. Da hade tillaggen aldrig kommit med i
           kopet. Samma sak med priset efter en variantrendering. */
        this.cartAddUrl = this.cartAddUrl || this.getAttribute('data-cart-add') || '/cart/add.js';
        if (!this._onAtc) {
          this._onAtc = this.onAtcClick.bind(this);
          document.addEventListener('click', this._onAtc, true);
        }
        if (!this._onVariantUpd) {
          this._onVariantUpd = function () { setTimeout(function () { self.updateCtaTotal(); }, 60); };
          document.addEventListener('variant:update', this._onVariantUpd);
        }
      }

      onAddon(e) {
        var d = (e && e.detail) || {};
        var id = parseInt(d.id, 10);
        if (!id) return;
        this.addonItems = this.addonItems || {};
        var key = String(id);
        if (d.remove || (d.toggle && this.addonItems[key])) delete this.addonItems[key];
        else this.addonItems[key] = { p: parseInt(d.price, 10) || 0 };
        /* Markeras sa att totalen gar tillbaka till serverns pris nar sista
           tillagget plockas bort - utan den stannar knappen pa pakettotalen. */
        this._addonTouched = true;
        this.syncAddonCards();
        this.updateCtaTotal();
        this.updateSaveText();
        this.rowsRefresh();
      }

      addonCount() { var n = 0; for (var k in (this.addonItems || {})) n++; return n; }
      addonSum() { var s = 0, i = this.addonItems || {}; for (var k in i) s += i[k].p || 0; return s; }

      /* Plusset blir en bock pa korten som ligger i paketet. Markeringen sitter
         pa VARIANTEN, inte pa kortet: byter kunden farg ar det en annan vara. */
      syncAddonCards() {
        var items = this.addonItems || {};
        this.querySelectorAll('on-fbt[data-bundle="1"] [data-fbt-add]').forEach(function (b) {
          var id = parseInt(b.getAttribute('data-variant'), 10);
          var pa = !!(id && items[String(id)]);
          b.classList.toggle('is-chosen', pa);
          b.setAttribute('aria-pressed', pa ? 'true' : 'false');
        });
      }

      /* Swatchbilderna i en par-rad, mot ratt kon. Raden klonas fran huvud-
         valjaren, alltsa bar den alltid sidans egna bilder till att borja med.
         srcset och sizes rensas: lamnas de kvar kan webblasaren valja en bild
         ur den GAMLA uppsattningen och bytet ser ut att inte ha hant. */
      applyPairImages(row) {
        if (!row || !this.swImgs) return;
        var alt = row.getAttribute('data-gender') === 'alt';
        var map = this.swImgs.alt;
        if (!map) return;
        var names = this.optNames || {};
        row.querySelectorAll('.on-variant-option').forEach(function (btn) {
          var img = btn.querySelector('.on-vp__swatch-img--var');
          if (!img) return;
          if (!img.hasAttribute('data-sw-src0')) {
            img.setAttribute('data-sw-src0', img.getAttribute('src') || '');
            img.setAttribute('data-sw-set0', img.getAttribute('srcset') || '');
          }
          var on = names[btn.getAttribute('data-fieldset-index')];
          var val = btn.getAttribute('data-value');
          if (!on || val === null) return;
          var url = alt ? map[on + '|' + val] : img.getAttribute('data-sw-src0');
          if (!url || img.getAttribute('src') === url) return;
          if (!alt) {
            var s0 = img.getAttribute('data-sw-set0');
            img.setAttribute('src', url);
            if (s0) img.setAttribute('srcset', s0);
            return;
          }
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.setAttribute('src', url);
        });
      }

      /* Rabatt-% för N par totalt (2 par = tier2, 3 = tier3, 4+ = tier4). Syncar med butikens mängdrabatter. */
      pctFor(n) {
        if (n <= 1) return 0;
        if (n === 2) return this.t2;
        if (n === 3) return this.t3;
        return this.t4;
      }

      /* Pris i butikens format. Följer Shopifys money_format-platshållare (butiken kör
         amount_no_decimals kr), så totalen ser exakt ut som serverrenderade priser. */
      money(cents) {
        /* NOK, PLN och EUR: landets eget sätt att skriva priser (omgång 36, on-design-tokens). */
        var loc = window.__onMoneyL ? window.__onMoneyL(cents) : null;
        if (loc !== null) return this.strip(loc);
        return this.strip(this.rawMoney(cents));
      }

      /* Butiken visar aldrig oren. Stadas priset forst efter att det skrivits ut
         hinner decimalerna synas en bildruta - darfor stads det HAR, fore utskrift. */
      strip(s) {
        return (window.__onNoDec ? window.__onNoDec(s) : s);
      }

      rawMoney(cents) {
        var format = this.getAttribute('data-money-format') || '';
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          try { return Shopify.formatMoney(cents, format); } catch (e) {}
        }
        var value = Number(cents || 0);
        function group(thousands, decimal, places) {
          var n = (value / 100).toFixed(places);
          var parts = n.split('.');
          var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return parts[1] ? int + decimal + parts[1] : int;
        }
        if (!format) return group(' ', ',', 2);
        return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, name) {
          switch (name) {
            case 'amount_no_decimals': return group(',', '.', 0);
            case 'amount_with_comma_separator': return group('.', ',', 2);
            case 'amount_no_decimals_with_comma_separator': return group('.', ',', 0);
            case 'amount_with_space_separator': return group(' ', ',', 2);
            case 'amount_no_decimals_with_space_separator': return group(' ', ',', 0);
            case 'amount_with_apostrophe_separator': return group("'", '.', 2);
            default: return group(',', '.', 2);
          }
        });
      }

      /* TOTALPRIS på köpknappen – speglar alla valda par + mängdrabatten.
         Använder EXAKT samma kontrakt som Paket/bundle (ON): skriver [data-cta-price]/
         [data-cta-compare] och sänder 'on-bundle:total' för den som vill spegla paketpriset. Ingen
         lyssnar i dag (rad 22): sticky-baren är slimmad och visar inget pris. */
      updateCtaTotal() {
        var nAdd = this.addonCount ? this.addonCount() : 0;
        if (!this.multi && !nAdd && !this._addonTouched) return;
        var rows = this.allPairs();
        var count = 1 + rows.length + nAdd;

        // Summera styckpriser: huvudväljaren + varje extra par (faller tillbaka på huvudvarianten).
        // reg = ordinarie pris (jämförpriset när det är högre), för lägena compare och save.
        var mainV = this.resolveVariant(this.rowValues(this.skin));
        var unit = mainV ? mainV.p : 0;
        var unitReg = mainV ? Math.max(mainV.c || 0, mainV.p) : 0;
        var sum = unit;
        var reg = unitReg;
        var self = this;
        Array.prototype.forEach.call(rows, function (row) {
          var v = self.resolveVariant(self.rowValues(row), self.listFor(row));
          sum += (v ? v.p : unit);
          reg += (v ? Math.max(v.c || 0, v.p) : unitReg);
        });
        var addon = this.addonSum ? this.addonSum() : 0;
        sum += addon;
        reg += addon;
        if (!sum) return;

        var pct = this.pctFor(count);
        var pay = Math.round(sum * (100 - pct) / 100);
        var payTxt = this.money(pay);
        var fullTxt = (pct > 0) ? this.money(sum) : '';
        var regTxt = (reg > pay) ? this.money(reg) : '';
        var saveTxt = (reg > pay) ? this.money(reg - pay) : '';

        // Skriv på köpknapparna (vanliga och fasta) i läget var och en har valt
        var scope = this.closest('.shopify-section') || document;
        this.writeCta(scope, payTxt, fullTxt, regTxt, saveTxt);
        // Sticky-ATC m.fl. lyssnar redan på detta event (samma som paketet skickar)
        try {
          this.dispatchEvent(new CustomEvent('on-bundle:total', { bubbles: true, detail: {
            qty: count, pay: payTxt, full: fullTxt
          } }));
        } catch (e) {}
      }

      /* Priset på köpknapparna (uppgift E). Varje knapp har sitt läge i data-cta-mode:
         qty = överstruket vid mängdrabatt (som förut), compare = överstruket ordinarie pris,
         save = "Spara X" (mallen i data-cta-save-t), none = bara priset. Samma kod i on-bundle.js. */
      writeCta(scope, pay, qty, reg, save) {
        Array.prototype.forEach.call(scope.querySelectorAll('[data-cta-price]'), function (el) {
          __onTxt(el, pay);
          var box = el.parentNode;
          var mode = (box && box.getAttribute && box.getAttribute('data-cta-mode')) || 'qty';
          var cmp = box.querySelector('[data-cta-compare]');
          var sv = box.querySelector('[data-cta-save]');
          var ct = mode === 'qty' ? qty : (mode === 'compare' ? reg : '');
          var st = (mode === 'save' && save) ? (box.getAttribute('data-cta-save-t') || '[x]').replace('[x]', save) : '';
          if (cmp) { __onTxt(cmp, ct); cmp.hidden = !ct; }
          if (sv) { __onTxt(sv, st); sv.hidden = !st; }
        });
      }

      /* Besparingstexten visar rabatten man LÅSER UPP genom att lägga till nästa par. */
      updateSaveText() {
        if (!this.saveEl) return;
        var extras = this.allPairs().length;
        extras += this.addonCount ? this.addonCount() : 0;
        var next = 1 + extras + 1;
        var maxTotal = 1 + this.maxPairs;
        if (next > maxTotal) next = maxTotal;
        var pctNext = this.pctFor(next);
        /* BOGO har sin egen mening om att andra plagget ar gratis och ska inte fa
           en belopps-mall trad over sig - den sager redan vad erbjudandet ar. */
        /* Köp N och spara X (omgång 54): hela köpets besparing vid nästa antal, ur samma trappa
           som kassan. Ingen rabatt på nästa steg = ingen rad, inget påhittat belopp. */
        if (this.saveMode === "buy" && !this.isBogo) {
          /* Taket nått: det finns inget nästa antal att erbjuda, så ingen rad. */
          var nu = 1 + extras;
          var bv = this.resolveVariant(this.rowValues(this.skin));
          var bu = bv ? bv.p : 0;
          /* Nedåt till hela enheter, som servern: aldrig mer än kassan ger. */
          /* Omgång 55: extra = bara det mängdrabatten ger utöver nuvarande antal (nästa minus
             nu, ur samma trappa), total = nedsättningen per par gånger antalet plus mängdrabatten
             (från ordinariepriset), plain = mängdrabatten vid nästa antal (omgång 54). */
          var ladder = bu * next * pctNext / 100;
          var raw = ladder;
          if (this.saveBuyKind === "extra") raw = ladder - bu * nu * this.pctFor(nu) / 100;
          else if (this.saveBuyKind === "total") { var bcmp = bv && bv.c > bu ? bv.c : 0; raw = ladder + (bcmp ? (bcmp - bu) * next : 0); }
          var bc = Math.floor(raw / 100) * 100;
          var bt = (next > nu && bu && pctNext > 0 && bc > 0 && this.saveBuyTmpl)
            ? this.saveBuyTmpl.split("[n]").join(String(next)).split("[m]").join(this.money(bc))
            : "";
          /* Omgång 56: alltid en rad. Ryms meningen inte krymper texten, sedan den korta
             formen ("Köp 2: spara 219 kr mer"), aldrig avbrutna ord. */
          var bts = bt && this.saveBuyTmplS
            ? this.saveBuyTmplS.split("[n]").join(String(next)).split("[m]").join(this.money(bc))
            : "";
          __onFitLine(this.saveEl, [bt, bts]);
          this.saveEl.hidden = !bt;
        } else if ((this.saveMode === "amount" || this.saveMode === "both") && this.saveAmtTmpl && !this.isBogo) {
          var sv = this.resolveVariant(this.rowValues(this.skin));
          var su = sv ? sv.p : 0;
          var txt = su
            ? this.saveAmtTmpl.split("[m]").join(this.money(Math.round(su * next * pctNext / 100)))
            : "";
          /* Bada-laget: beloppet forst, procenten efter. Samma ordning som
             server-renderingen, annars byter raden plats framfor ogonen nar
             JS tar over. */
          if (txt && this.saveMode === "both") txt += " · −" + Math.round(pctNext) + "%";
          __onFitLine(this.saveEl, [txt]);
        } else {
          /* Texten visar heltal aven nar rakningen bar decimaler. */
          __onFitLine(this.saveEl, [(this.saveTmpl || "").split("[p]").join(Math.round(pctNext))]);
        }
        this.updateUnitPrice(next);
      }

      /* Vad EN vara kostar om man tar nasta antal. Rakningen utgar fran den valda
         variantens pris, sa den foljer med nar besokaren byter storlek eller farg.
         money() ar samma formattering som knappens totalpris anvander, alltsa samma
         valuta och samma tusentalsavgransare som resten av sidan. */
      updateUnitPrice(next) {
        if (!this.unitEl) return;
        var v = this.resolveVariant(this.rowValues(this.skin));
        var unit = v ? v.p : 0;
        if (!unit) { __onTxt(this.unitEl, ''); if (this.unitWasEl) this.unitWasEl.hidden = true; return; }
        var pct = this.pctFor(next);
        /* BOGO: hela summan for de tva och ordinarie summan overstruken.
           Ovriga: styckpriset, som forut. */
        var wantTotal = this.isBogo || this.priceMode === 'total';
        var each = wantTotal
          ? Math.round(unit * next * (100 - pct) / 100)
          : Math.round(unit * (100 - pct) / 100);
        var wasAmt = wantTotal ? unit * next : unit;
        /* Ordet ("Styckpris") och sjalva siffran hamnar i varsin span sa de kan
           fargas var for sig i temaeditorn. Bara textContent satts - ingen HTML. */
        var uParts = ((wantTotal ? this.totalTmpl : this.unitTmpl) || '[m]').split('[m]');
        __onTxt(this.unitEl, '');
        for (var ui = 0; ui < uParts.length; ui++) {
          if (uParts[ui]) {
            var uLbl = document.createElement('span');
            uLbl.className = 'on-vp-multi__unit-lbl';
            __onTxt(uLbl, uParts[ui]);
            this.unitEl.appendChild(uLbl);
          }
          if (ui < uParts.length - 1) {
            var uAmt = document.createElement('span');
            uAmt.className = 'on-vp-multi__unit-amt';
            __onTxt(uAmt, this.money(each));
            this.unitEl.appendChild(uAmt);
          }
        }
        if (this.unitWasEl) {
          if (pct > 0) { __onTxt(this.unitWasEl, this.money(wasAmt)); this.unitWasEl.hidden = false; }
          else { __onTxt(this.unitWasEl, ''); this.unitWasEl.hidden = true; }
        }
      }

      /* ── BOGO-sparren ──────────────────────────────────────────────────────
         Kravet ar att kunden aktivt valt i varje optionsgrupp pa BADA plaggen.
         Shopify har alltid en variant vald internt, sa "nagot ar valt" duger
         inte som matt: vi markerar i stallet varje grupp med data-bogo-unset
         och tar bort market nar kunden sjalv tryckt i den. Det ar ocksa darfor
         sparren inte kan byggas pa sizeGate, som bara kanner till storleken. */
      initBogoGate() {
        if (!this.isBogo || !this.skin) return;
        /* Storleks-sparren ar en delmangd av den har. Lamnas bada pa skriver de
           over varandras knapptext. */
        if (this.sizeGate) {
          this.sizeGate = false;
          if (this.sizeGroup) this.sizeGroup.removeAttribute('data-unchosen');
          if (this._onAtcGate) { document.removeEventListener('click', this._onAtcGate, true); this._onAtcGate = null; }
        }
        this.bogoGate = true;
        this.pickText = this.getAttribute('data-bogo-gate') || 'Choose both items';
        var self = this;
        this.skin.querySelectorAll('.on-vp__group').forEach(function (g) {
          self.clearGroup(g);
          g.setAttribute('data-bogo-unset', '');
        });
        this.updateBogoGate();
        /* Kopknappen i sidan renderas EFTER valjaren, sa forsta passet hittar
           bara den fasta baren. Tva sena omtag fangar den. */
        setTimeout(function () { self.updateBogoGate(); }, 0);
        setTimeout(function () { self.updateBogoGate(); }, 600);
      }

      /* Tommer en grupp helt: ingen aktiv knapp, ingen etikettext. */
      clearGroup(group) {
        if (!group) return;
        group.querySelectorAll('.on-variant-option').forEach(function (b) { b.classList.remove('is-active'); });
        var cur = group.querySelector('[data-current-text]');
        if (cur) __onTxt(cur, '');
        var dd = group.querySelector('[data-dd-current-text]');
        if (dd) __onTxt(dd, '');
      }

      /* Alla grupper som fortfarande vantar pa ett val, i lasordning. */
      bogoUnset() {
        var ut = [];
        var push = function (g) { ut.push(g); };
        if (this.skin) this.skin.querySelectorAll('.on-vp__group[data-bogo-unset]').forEach(push);
        if (this.extrasEl) this.extrasEl.querySelectorAll('.on-vp__group[data-bogo-unset]').forEach(push);
        return ut;
      }

      bogoReady() {
        if (!this.isBogo) return true;
        return this.bogoUnset().length === 0;
      }

      updateBogoGate() {
        if (!this.isBogo || !this.bogoGate) return;
        var klar = this.bogoReady();
        this.lockScope(!klar);
        this.setAtcPrompt(!klar);
      }

      /* Blinka till pa forsta gruppen som saknas och rulla dit. Kunden ska se
         VAD som fattas, inte bara att knappen inte gor nagot. */
      nudgeUnset() {
        var kvar = this.bogoUnset();
        if (!kvar.length) return;
        var g = kvar[0];
        g.setAttribute('data-bogo-nudge', '');
        setTimeout(function () { g.removeAttribute('data-bogo-nudge'); }, 900);
        try { g.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { g.scrollIntoView(); }
      }

      rowValues(row) {
        var vals = [];
        row.querySelectorAll('.on-vp__group').forEach(function (g) {
          var fi = parseInt(g.getAttribute('data-fieldset-index'), 10);
          var a = g.querySelector('.on-variant-option.is-active');
          vals[fi] = a ? a.getAttribute('data-value') : null;
        });
        return vals;
      }

      /* Vilken produkts varianter galler for den har raden. Huvudvaljaren och
         rader utan vaxling anvander produktens egna; en rad som stallts om till
         motparten anvander dennes. */
      listFor(row) {
        if (row && row.getAttribute && row.getAttribute('data-gender') === 'alt' && this.altVariants && this.altVariants.length) return this.altVariants;
        return this.vpVariants;
      }

      resolveVariant(values, list) {
        var lista = list || this.vpVariants;
        for (var i = 0; i < lista.length; i++) {
          var v = lista[i], ok = true;
          for (var k = 0; k < values.length; k++) {
            if (values[k] == null) continue;
            if ((v.o[k] || '') !== values[k]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      /* Deterministisk hash av variant-id (FNV-1a) → samma visning för alla besökare. */
      hashId(id) {
        var s = String(id), h = 2166136261 >>> 0;
        for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
        return h;
      }

      updatePairStock(row) {
        if (!row) return;
        var v = this.resolveVariant(this.rowValues(row), this.listFor(row));
        var chip = row.querySelector('[data-vp-stock]');
        var avail = !!(v && v.av);
        row.classList.toggle('is-unavailable', !avail);
        if (!chip) return;
        // IDENTISK design + regel som huvudväljarens lagernotis (samma klasser, dot-inställning,
        // deterministisk delmängd per variant-ID och 5–28). Slutsåld visas i samma layout.
        var dotHtml = (this.stockDot === 'none') ? '' : '<span class="on-vp__low-dot"></span>';
        chip.style.setProperty('--on-vp-stock-dot', this.stockDotColor || '#f46245');
        chip.style.setProperty('--on-vp-stock-text', this.stockTextColor || '#111');
        if (!avail) {
          chip.className = 'on-vp__low on-vp-pair__stock';
          chip.innerHTML = dotHtml + '<span class="on-vp__low-text"></span>';
          __onTxt(chip.querySelector('.on-vp__low-text'), this.soldOutTxt);
          chip.hidden = false;
          return;
        }
        var h = this.hashId(v.id);
        if ((h % 100) >= 55) {
          /* Ingen lagernotis pa den har varianten - visa i-lager-beskedet i stallet,
             samma regel som huvudvaljarens rad sa paret inte star tomt. */
          if (!this.readyTxt) { chip.hidden = true; chip.innerHTML = ''; return; }
          chip.className = 'on-vp__low on-vp__low--ready on-vp-pair__stock' + (this.stockDot === 'pulse' ? ' on-vp__low--pulse' : '');
          chip.style.setProperty('--on-vp-stock-dot', this.readyDotColor || '#1E7A3C');
          chip.innerHTML = dotHtml + '<span class="on-vp__low-text"></span>';
          __onTxt(chip.querySelector('.on-vp__low-text'), this.readyTxt);
          chip.hidden = false;
          return;
        }
        var count = 5 + ((h >>> 7) % 24); // 5..28, fast per variant
        chip.className = 'on-vp__low on-vp-pair__stock' + (this.stockDot === 'pulse' ? ' on-vp__low--pulse' : '');
        chip.innerHTML = dotHtml + '<span class="on-vp__low-text"></span>';
        chip.querySelector('.on-vp__low-text').textContent =
          (this.getAttribute('data-upre') || '') + ' ' + count + ' ' + (this.getAttribute('data-upost') || '');
        chip.hidden = false;
      }

      onAtcClick(e) {
        var nAdd = this.addonCount ? this.addonCount() : 0;
        if ((!this.multi || !this.extrasEl) && !nAdd) return;
        var btn = e.target.closest('.add-to-cart-button, button[name="add"]');
        if (!btn || !this.section.contains(btn)) return;
        /* BOGO: inget kop innan bada plaggen ar helt valda. Kollen ligger HAR,
           i samma hanterare som lagger i varukorgen, i stallet for i en egen
           lyssnare - tva capture-lyssnare pa document kor i registreringsordning,
           och da hade sparren kunnat springas om av kopet. */
        if (this.isBogo && !this.bogoReady()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.armPending();
          this.nudgeUnset();
          return;
        }
        /* Radläget (omgång 49): ett par i rutan som saknar val stoppar köpet, och
           valet som saknas markeras. Inget läggs i korgen. */
        if (this.rowsEl && this.pairsUnset().length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.nudgePairs();
          return;
        }
        // Varken extra par eller tillagg → native skoter kopet
        if (!this.allPairs().length && !nAdd) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.addMulti(btn);
      }

      addMulti(btn) {
        var self = this;
        var map = {};
        function add(id, n) { if (!id) return; map[id] = (map[id] || 0) + (n || 1); }

        var qtyInput = this.section.querySelector ? this.section.querySelector('input[name="quantity"]') : null;
        var mainQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var mainV = this.resolveVariant(this.currentMainValues());
        var pairV = [];
        this.allPairs().forEach(function (row) {
          var v = self.resolveVariant(self.rowValues(row), self.listFor(row));
          if (v && v.av) pairV.push(v.id);
          else { row.classList.add('is-unavailable'); self.updatePairStock(row); }
        });
        /* Köp-1-få-1 (omgång 53): formulärets antal (dolt 2, eller antalsväljaren som stegar
           2, 4, 6) räknar hela paret. Gratisparen läggs som egna rader, så förstaparet blir
           antalet minus dem, och summan av enheter för produkten blir alltid jämn. */
        if (this.isBogo) mainQty = Math.max(1, mainQty - pairV.length);
        if (this.isBogo && (mainQty + pairV.length) % 2) mainQty++;
        if (mainV && mainV.av) add(mainV.id, mainQty);
        pairV.forEach(function (id) { add(id, 1); });
        // Tillaggen ligger i samma anrop som paret, alltsa ett kop och en rabatt.
        var ai = this.addonItems || {};
        for (var ak in ai) add(parseInt(ak, 10), 1);

        var items = [];
        for (var id in map) items.push({ id: parseInt(id, 10), quantity: map[id] });
        if (!items.length) return;

        var body = { items: items };
        var cic = document.querySelector('cart-items-component');
        var sectionId = cic ? (cic.getAttribute('section-id') || cic.getAttribute('data-section-id')) : null;
        if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }

        if (btn) btn.setAttribute('aria-busy', 'true');
        fetch(this.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (added) {
            if (added && added.status && added.status >= 400) throw new Error('add failed');
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
              .then(function (cart) { self.openDrawer(cart, added.sections); });
          })
          .catch(function () { /* Direkt varukorg (omgång 83) visar felet i lådan; utan den: korgsidan. */ if (!window.__onOc) window.location.href = '/cart'; })
          .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
      }

      openDrawer(cart, sections) {
        var detail = { resource: cart, sourceId: 'on-variant-picker', data: { source: 'on-variant-picker', itemCount: cart.item_count, sections: sections } };
        // Ingen popup ska poppa upp ovanpa (eller bakom) varukorgen efter ett kop.
        try { if (window.onPopupGate) window.onPopupGate.block('cart'); } catch (e) {}
        // cart:update ar samma handelse som Horizons CartAddEvent: den uppdaterar
        // antalet i bubblan OCH triggar ladans auto-open.
        try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail })); } catch (e) {}
        var drawer = document.querySelector('cart-drawer-component');
        if (!drawer) { window.location.href = '/cart'; return; }
        try { if (typeof drawer.open === 'function') drawer.open(); } catch (e) {}
        // Horizons showDialog() kor sitt showModal() inne i requestAnimationFrame.
        // Strypes rAF (bakgrundad flik, sparlage) kommer den aldrig, och kunden star
        // kvar utan varukorg helt tyst. Vi kollar efterat och oppnar sjalva.
        setTimeout(function () {
          var dlg = drawer.querySelector('dialog');
          if (dlg && !dlg.open) { try { dlg.showModal(); } catch (e) { window.location.href = '/cart'; } }
        }, 350);
      }
    }

    customElements.define('on-variant-picker', OnVariantPicker);
  })();
